import { AccordionSummary as MuiAccordionSummary, styled } from '@mui/material';

export const AccordionSummary = styled(MuiAccordionSummary)({
  '& .MuiAccordionSummary-expandIconWrapper': {
    marginRight: 0,
  },
});
